<h2 mat-dialog-title>{{user.email ? user.email : 'Create User'}}</h2>

<form [formGroup]="formGroup" (ngSubmit)="user.id ? update() : create()" fxLayout="column">

  <mat-dialog-content>
    @if (user) {
      <div class="user-form-panel">
        @if (!user.id) {
          <bt-form-field>
            <mat-form-field appearance="outline" fxFill>
              <mat-label>{{ 'user.label.email' | translate}}</mat-label>
              <input matInput name="email" formControlName="email" [placeholder]="'user.label.email.placeholder' | translate" required/>
              @if (formGroup.get('email').touched && formGroup.get('email').hasError('required')) {
                <mat-error>
                  {{ 'user.label.email.error' | translate }}
                </mat-error>
              }
              @if (formGroup.get('email').touched && formGroup.get('email').hasError('email')) {
                <mat-error>
                  {{ 'user.label.email.invalid' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </bt-form-field>
        }
        <bt-form-field>
          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'user.label.firstName' | translate }}</mat-label>
            <input matInput name="firstName" formControlName="firstName" [placeholder]="'user.label.firstName.placeholder' | translate" required/>
            @if (formGroup.get('firstName').touched && (formGroup.get('firstName').hasError('required') || formGroup.get('firstName').hasError('whitespace'))) {
              <mat-error>
                {{ 'user.label.firstName.error' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </bt-form-field>
        <bt-form-field>
          <mat-form-field appearance="outline" fxFill>
            <mat-label> {{ 'user.label.lastName' | translate}}</mat-label>
            <input matInput name="lastName" formControlName="lastName" [placeholder]="'user.label.lastName.placeholder' | translate" required/>
            @if (formGroup.get('lastName').touched && (formGroup.get('lastName').hasError('required') || formGroup.get('lastName').hasError('whitespace'))) {
              <mat-error>
                {{ 'user.label.lastName.error' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <bt-form-errors></bt-form-errors>
        </bt-form-field>
        <bt-form-field *hasAccess="['admin']" errorName="organization">
          <mat-form-field appearance="outline" fxFill>
            <mat-label> {{ 'user.label.organization' | translate}}</mat-label>
            <mat-select formControlName="organizationId" panelClass="selectPopupFull">
              <mat-option [value]="null" class="null-option">
                {{ currentUser.roles.includes("admin") ? "-No Organization-" : "-Select Organization-" }}
              </mat-option>
              @for (org of orgs; track org) {
                <mat-option [value]="org.id">
                  {{org.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <bt-field-errors></bt-field-errors>
        </bt-form-field>
        @if (selectedOrg?.orgType !== 'fmcg') {
          <bt-form-field errorName="store">
            <mat-form-field color="accent" appearance="outline">
              <mat-label>{{ 'user.label.homeStore' | translate}}</mat-label>
              <mat-select formControlName="homeStoreId" panelClass="selectPopupFull">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="homeStoreSearchControl"
                    [placeholderLabel]="'user.label.homeStore.placeholder' | translate"
                    [noEntriesFoundLabel]="'user.label.homeStore.noFound' | translate"
                  ></ngx-mat-select-search>
                </mat-option>
                @if (!homeStoreSearchControl.value) {
                  <mat-option [value]="null" class="null-option">
                    {{ currentUser.roles.includes("admin") ? "-No Home Store-" : "-Select Home Store-" }}
                  </mat-option>
                }
                @for (store of filteredHomeStores; track store) {
                  <mat-option class="mat-accent"
                    [value]="store.id">
                    {{ store.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <bt-field-errors></bt-field-errors>
          </bt-form-field>
        }
        @if (potentialStoreIds !== 'unrestricted' && this.currentUser?.id !== user?.id) {
          <bt-form-field errorName="store">
            <mat-form-field appearance="outline" fxFill>
              <!--
              If singleStoreRestricted is FALSE, show multi-select.
              Otherwise, show single-select.
              -->
              @if (!singleStoreRestricted) {
                <!-- ===================== MULTI-SELECT VERSION ===================== -->
                <mat-label>{{ 'user.label.allowedStores' | translate }}</mat-label>
                <mat-select
                  formControlName="storeIds"
                  panelClass="selectPopupFull"
                  multiple
                  [disableOptionCentering]="true"
                  >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="storeSearchControl"
                      [placeholderLabel]="'user.select.store.placeholder' | translate"
                      [noEntriesFoundLabel]="'user.select.store.noFound' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <!-- Multi-select options -->
                  @for (store of filteredStores; track store) {
                    <mat-option [value]="store.id">
                      {{ store.name }}
                    </mat-option>
                  }
                </mat-select>
              } @else {
                <mat-label>{{ 'user.label.allowedStore' | translate }}</mat-label>
                <mat-select
                  formControlName="singleStoreSelection"
                  panelClass="selectPopupFull"
                  [disableOptionCentering]="true"
                  (selectionChange)="onSingleStoreSelection($event)">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="storeSearchControl" [placeholderLabel]="'user.select.store.placeholder' | translate" [noEntriesFoundLabel]="'user.select.store.noFound' | translate">
                    </ngx-mat-select-search>
                  </mat-option>
                  <!-- Single-select options -->
                  @if (!storeSearchControl.value) {
                    <mat-option [value]="null" class="null-option">
                      {{ currentUser.roles.includes("admin") ? "-No Allowed Store-" : "-Select Allowed Store-" }}
                    </mat-option>
                  }
                  @for (store of filteredStores; track store) {
                    <mat-option [value]="store.id">
                      {{ store.name }}
                    </mat-option>
                  }
                </mat-select>
              }
              <!-- ===================== SINGLE-SELECT VERSION ===================== -->
            </mat-form-field>
            <bt-field-errors></bt-field-errors>
          </bt-form-field>
        }
        <bt-form-field *hasAccess="['organization_admin', 'Organization Executive', 'Regional Manager', 'Store Manager', 'IT']">
          @if (roleOptions.length > 0) {
            <mat-form-field appearance="outline" fxFill>
              <mat-label>{{ 'user.label.roles' | translate }}</mat-label>
              <mat-select formControlName="roles" panelClass="selectPopupFull" multiple>
                @for (role of roleOptions; track role) {
                  <mat-option [value]="role">{{role | titlecase}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <bt-field-errors></bt-field-errors>
        </bt-form-field>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button [matDialogClose]=""> {{ 'general.action.cancel' | translate}}</button>
    <button mat-flat-button color="primary" type="submit"
    [disabled]="formGroup.invalid">{{user.id ? ('general.action.save' | translate)  :  ('general.action.create' | translate)}}</button>
  </mat-dialog-actions>
</form>
